export const BYTES_PER_MEGABYTE = 1000000;
